import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { getTenantInfoByKey, replaceExpecialCharacters } from '../../../helpers/helpers';
import { CustomSelectComplex } from '../../CustomSelectComplex/CustomSelectComplex';
import { Input, FormGroup, Spinner } from 'reactstrap';
import BuildingsManagementContext from '../../../context/BuildingManagementContext/BuildingsManagementContext';
import { ButtonBlue } from '../../Buttons/ButtonBlue';
import { CustomModal } from '../../CustomModal/CustomModal';
import errorIcon from '../../../assets/icons/triangule-exclamation.svg';
import buildingSuccessIcon from '../../../assets/icons/building-success-icon.svg';
import AreasManagementContext from '../../../context/AreasManagementContext/AreasManagementContext';

export const CreateAndEditArea = () => {
    const navigate = useNavigate();
    const { areaId } = useParams();
    const isEditing = areaId;

    const { areasManagementState, getArea, createArea, editArea } = useContext(AreasManagementContext);
    const { areaData, areasToConfig, isFetching, responseAreaService } = areasManagementState;

    const { buildingsManagementState, getBuildingsManagement } = useContext(BuildingsManagementContext);
    const { buildingsToConfig } = buildingsManagementState;

    const buildingOptions = buildingsToConfig.map(building => ({ label: `${building.buildingCode} - ${building.buildingDescription}`, value: building.buildingId, target: { value: `${building.buildingId}`, name: 'buildingId' } }));

    const [areaDataState, setAreaDataState] = useState(areaData);

    const disabled = (!areaDataState.buildingId) || !!!String(areaDataState.areaCode).trim() || !!!String(areaDataState.areaDescription).trim();

    const nameOfBuildings = getTenantInfoByKey('building_name');

    const handleChange = (e, selectName) => {

        if (selectName === 'buildingId' && e === null) {
            return setAreaDataState({
                ...areaDataState,
                'buildingId': null
            })
        }

        let { value, name, checked } = e.target;

        setAreaDataState({
            ...areaDataState,
            [name]: name === 'areaEnabled' ? checked : replaceExpecialCharacters(value)
        })
    }

    const handleSubmit = async () => {
        if (disabled) return
        if (areaId) {
            return await editArea(areaDataState);
        }
        await createArea(areaDataState);
    }

    const closeWarningModal = async () => navigate('/settings/entityManagment/areasMaganagement');

    const goCancel = () => navigate(-1);

    const getAreaAndLoadData = async () => {
        const response = await getArea(areaId);
        setAreaDataState(response);
    }

    useEffect(() => {
        if (buildingsToConfig.length === 0) {
            getBuildingsManagement();
        }

        if (isEditing && areasToConfig.length === 0) {
            getAreaAndLoadData()
        }
        // eslint-disable-next-line
    }, []);

    return (

        <div className='row justify-content-center'>
            <div className='col-xl-4 col-lg-7 col-sm-9 mt-5'>
                <div className='me-3 ms-3 mt-2'>

                    <CustomModal showModal={responseAreaService.show} centered={true} setShowModal={closeWarningModal}>
                        <div className='d-flex flex-column align-items-center justify-content-center'>
                            <img src={responseAreaService.type === 'ERROR' ? errorIcon : buildingSuccessIcon} alt="" />
                            <p className='mt-3 text-center param-section-title'>{responseAreaService.text}</p>
                            <p type="button" className='custom-modal-btn-ok' onClick={closeWarningModal}>{t('UNDERSTOOD')}</p>
                        </div>
                    </CustomModal>

                    {isFetching ?
                        <div className="d-flex mt-4 justify-content-center">
                            <Spinner />
                        </div>
                        : null}

                    <div>
                        <p className='m-0 titlelabel-filter'>{t('CODE')}</p>
                        <p>
                            <input
                                className='form-control'
                                type="text"
                                name='areaCode'
                                value={areaDataState.areaCode}
                                onChange={handleChange}
                                disabled={areaId ? true : false}
                            />
                        </p>
                    </div>

                    <div>
                        <label
                            htmlFor="areaDescription"
                            className="titlelabel-filter"
                        >
                            {t('DESCRIPTION')}
                        </label>
                        <textarea
                            className='form-control'
                            name="areaDescription"
                            cols="30"
                            rows="5"
                            value={areaDataState.areaDescription}
                            placeholder={t('ENTER_DESCRIPTION')}
                            maxLength={255}
                            onChange={handleChange}
                        >
                        </textarea>
                    </div>

                    <div className='mt-2'>
                        <label
                            className="form-label titlelabel-filter"
                            htmlFor="contractors"
                        >
                            {nameOfBuildings}
                        </label>

                        <CustomSelectComplex
                            options={buildingOptions}
                            value={buildingOptions.find(options => options.value === areaDataState.buildingId)}
                            name={'buildingId'}
                            placeholder={t('SELECT')}
                            isClearable={true}
                            onChange={(e) => handleChange(e, 'buildingId')}
                        />
                    </div>

                    <div className='mt-3'>
                        <div style={{ backgroundColor: '#FFFFFF', borderRadius: '5px' }} className='p-2 d-flex justify-content-between align-items-center'>
                            <div>
                                <p className='m-0'>{areaDataState.areaEnabled ? t('ENABLED') : t('NOT_ENABLED')}</p>
                            </div>

                            <div>
                                <FormGroup switch>
                                    <Input type="switch" name='areaEnabled' checked={areaDataState.areaEnabled} onClick={handleChange} />
                                </FormGroup>
                            </div>
                        </div>


                        <div className='d-flex justify-content-around align-items-center mt-5 mb-4'>
                            <div className=''>
                                <p type='button' className='m-0' onClick={goCancel}>{t('CANCEL')}</p>
                            </div>

                            <div className=''>
                                <ButtonBlue onClick={handleSubmit} disabled={disabled}>
                                    {t('SAVE')}
                                </ButtonBlue>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
